import script from "./TopLoadingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopLoadingBar.vue?vue&type=script&setup=true&lang=js"

import "./TopLoadingBar.vue?vue&type=style&index=0&id=56b4af80&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b4af80"]])

export default __exports__